<script setup lang="ts">
import { computed } from 'vue'

import { getClasses } from '~/js/composables/classes'
import { getGlobalTranslation } from '~/js/composables/translations'
import { Analytics } from '~/js/interfaces/analytics'

import IconFa from '~/vue/_teammasters/atoms/icons/IconFa.vue'

interface Props {
    text: string
    ga?: Analytics | null,
}

const props = withDefaults(defineProps<Props>(), {
    ga: null,
    category: null
})

const classes = {
    _default: 'cursor-pointer rounded-lg',
    animate: 'transition-colors',
    dislay: 'flex items-center gap-2',
    color: 'bg-yellow',
    text: 'font-primary text-sm',
    spacing: 'px-2 py-1',
    hover: 'hover:bg-yellow/50',
    focus: 'focus-visible:ring-2 focus-visible:ring-offset-white dark:ring-offset-black focus-visible:ring-offset-2 focus-visible:outline-none focus-visible:ring-indigo'
}

const attributes = computed(() => {
    if (props.ga == null) {
        return {}
    }

    return {
        'data-tag-category': props.ga?.category ?? '',
        'data-tag-action': props.ga?.action ?? '',
        'data-tag-label': props.ga?.label ?? '',
    }
})
</script>

<template>
    <button 
        :class="getClasses(classes)"
        :aria-label="`${getGlobalTranslation('Clear filter')} ${text}`"
        v-bind="attributes"
    >
        <span>{{ text }}</span>
        <IconFa icon="fas fa-times" />    
    </button>
</template>